import { AppDashboard } from "@/pages/App/AppDashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/")({
  component: AppDashboard,
});
